module.exports = __webpack_public_path__ + "50aab53e6b6495893d5e828af12525d0.png";